
import { computed } from '@vue/composition-api';
import LazyHydrate from 'vue-lazy-hydration';
import { formatPrice } from '@artmizu/utils';
import type { Product } from '~/type/product/Product';
import TSProductCardSlider from '~/components/ts-components/TSProductCardSlider/TSProductCardSlider.vue';
import TSBonusCount from '~/components/ts-components/TSBonusCount/TSBonusCount.vue';
import TSProductRating from '~/components/ts-components/TSProductRating/TSProductRating.vue';
import TSPrice from '~/components/ts-components/TSPrice/TSPrice.vue';
import TSCounter from '~/components/ts-components/TSCounter/TSCounter.vue';
import CartTool from '~/components/CartTool/CartTool.vue';
import SaleMarkerList from '~/components/SaleMarkerList/SaleMarkerList.vue';
import { useProductMoreStore } from '~/store/modal/productMore';
import ActionCompare from '~/action/ActionCompare.vue';
import ActionFavorite from '~/action/ActionFavorite.vue';
import ActionCart from '~/action/ActionCart.vue';
import { useUserListStore } from '~/store/userLists';
interface Props {
  product: Product;
  /**
  * Должна ли карточке адаптироваться на мобильныйх устройствах
  */
  adaptive?: boolean;
  /**
   * Вид карточки товара
   */
  mobileType?: 'grid' | 'list';
  /**
  * Нужно ли делать элементы компактными
  */
  compact?: boolean;
  /**
   * Внутренние отступы
   */
  paddingTop?: string;
  paddingLeft?: string;
  paddingBottom?: string;
  paddingRight?: string;
  /**
  * Нужен ли лоад для изображения
  */
  photoLazyload?: boolean;
  /**
   * Показывать ли:
   * mobile-border - границы в мобильной версии
   * mobile-more - кнопка с тремя точками в мобильной версии
   * desktop-tools - user-tools (кнопки избранного и сравнения) в десктоп версии
   * bonus - плашка с бонусами
   * price - цена
   * mobile-favorite - кнопка избранного в мобильной версии
   * product-card-slider - слайдер изображений
   */
  hide?: ('mobile-border' | 'mobile-more' | 'desktop-tools' | 'bonus' | 'price' | 'mobile-favorite' | 'product-card-slider')[];
  source?: string;
  itemIndex?: number;
}
const __sfc_main = {};
__sfc_main.props = {
  product: {
    key: "product",
    required: true,
    type: null
  },
  adaptive: {
    key: "adaptive",
    required: false,
    type: Boolean,
    default: false
  },
  mobileType: {
    key: "mobileType",
    required: false,
    type: String,
    default: 'grid'
  },
  compact: {
    key: "compact",
    required: false,
    type: Boolean,
    default: false
  },
  paddingTop: {
    key: "paddingTop",
    required: false,
    type: String
  },
  paddingLeft: {
    key: "paddingLeft",
    required: false,
    type: String
  },
  paddingBottom: {
    key: "paddingBottom",
    required: false,
    type: String
  },
  paddingRight: {
    key: "paddingRight",
    required: false,
    type: String
  },
  photoLazyload: {
    key: "photoLazyload",
    required: false,
    type: Boolean,
    default: true
  },
  hide: {
    key: "hide",
    required: false,
    type: Array
  },
  source: {
    key: "source",
    required: false,
    type: String
  },
  itemIndex: {
    key: "itemIndex",
    required: false,
    type: Number
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const emit = __ctx.emit;
  const userListStore = useUserListStore();
  const isCompare = computed(() => userListStore.compare);
  const isFavorite = computed(() => userListStore.favorite);
  const {
    enableProductMore
  } = useProductMoreStore();
  const mainPropertyArray = computed(() => {
    // У нас достаточно занятная зависимость отображения количества характеристик и акций на карточку
    // Если у карточки 3 и более акции - можно вывести максимум 2 характеристики
    // Если 2 акции - можно вывести максимум 3 характеристики
    // Если 1 акция - можно вывести максимум 4 характеристики
    // Если акций нет - можно вывести максимум 5 характеристик
    if (props.product?.sale?.length >= 3) return props.product?.mainProperty?.slice(0, 2);
    return props.product?.mainProperty?.slice(0, 5 - props.product?.sale?.length);
  });
  const downPayment = computed(() => {
    const price = props.product?.price?.common.value ?? 0;
    if (price < 3000 || price > 200000) return 0;
    const percent = price < 110000 ? 30 : 45;
    const value = price * percent / 100;
    return Math.ceil(value / 10) * 10;
  });
  const isToolsActive = computed(() => {
    return !!isCompare.value[props.product.id] || !!isFavorite.value[props.product.id];
  });
  const isPreOrder = computed(() => props.product.status?.code === 'PRE_ORDER');
  return {
    formatPrice,
    emit,
    enableProductMore,
    mainPropertyArray,
    downPayment,
    isToolsActive,
    isPreOrder
  };
};
__sfc_main.components = Object.assign({
  LazyHydrate,
  ActionCompare,
  ActionFavorite,
  TSBonusCount,
  TSProductCardSlider,
  TSProductRating,
  SaleMarkerList,
  TSPrice,
  ActionCart,
  TSCounter,
  CartTool
}, __sfc_main.components);
export default __sfc_main;
